module.exports = __webpack_public_path__ + "static/img/logo_cds.c3a3a24a.png";